"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFarm = function IconFarm(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m33.604 9.903-9.71-5.027L14.01 9.9 6.836 19.918 10 22.033v12.5a7.74 7.74 0 0 0-5.611 3.374q.622.876 1.318 1.692a5.74 5.74 0 0 1 5.324-3.1c3.222-.09 5.859 2.383 5.97 5.536l.035 1 1.999-.07-.036-1-.012-.244A7.74 7.74 0 0 0 12 34.53v-11.16l.012.008 5.253-8.21 6.535-3.327 6.544 3.326L35 22.445V43h2V22.44l3.763-2.523zm-9.719-2.779 8.371 4.333 5.681 7.946-1.756 1.177-4.445-6.948L23.8 9.598l-7.926 4.034-4.447 6.95-1.763-1.18 5.687-7.942zM32 27v16h-2V29H16v-2zm-5-10h-7v7h7zm-1 1v5h-5v-5z",
    clipRule: "evenodd"
  })));
};

export { IconFarm, IconFarm as default };
